import { render } from "./sets.vue?vue&type=template&id=396e57a2"
import script from "./sets.vue?vue&type=script&lang=js"
export * from "./sets.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__